import React from 'react';
import {BaseIconProps} from '../../types';

//Perhaps find a better way to do this, rather than making thick icons? ask Marek?
export const BaseMinusThick: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11.25C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75C9.44861 12.75 15.0388 12.75 6 12.75C5.58579 12.75 5.25 12.4142 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25C15.0719 11.25 9.40869 11.25 18 11.25Z"
        fill={color}
      />
    </svg>
  );
};
